import { useState, useEffect, useCallback } from 'react';

/**
 * Заглушка хука определения бездействия пользователя (без функциональности)
 * 
 * @param idleTime Время бездействия в миллисекундах (не используется)
 * @param onIdle Функция, вызываемая при бездействии (не будет вызываться)
 * @param events События для отслеживания (не используется)
 * @returns Объект с состоянием бездействия (всегда false)
 */
export function useIdleDetection(
  idleTime: number = 3000,
  onIdle?: () => void,
  events: string[] = ['mousemove', 'keydown', 'mousedown', 'touchstart']
) {
  const [isIdle, setIsIdle] = useState<boolean>(false);

  // Просто для совместимости API - ничего не делает
  const resetIdleTimer = useCallback(() => {
    console.log('useIdleDetection: Вызов заглушки resetIdleTimer');
    setIsIdle(false);
  }, []);

  // Уведомление в консоли
  useEffect(() => {
    console.log('useIdleDetection: Инициализирована заглушка обнаружения бездействия');
    return () => {
      console.log('useIdleDetection: Заглушка обнаружения бездействия удалена');
    };
  }, []);

  return {
    isIdle,
    resetIdleTimer
  };
} 